import React, { useEffect, useState, Fragment } from 'react';
import { StateModel } from '../../redux/store';
import { connect } from 'react-redux';
import { Message } from '../../api';
import Modal from '../../components/modal/Modal';
import Button from '../../components/button/Button';
import { removeNotification } from '../../utils/notificationUtils';
interface NotificationProps {
  messageList: Message[];
  newNotification: boolean;
}

export const ERROR = 'ERROR';
export const INFO = 'INFO';
export const FORM_VALIDATION = 'FormValidation';

const Notification = (props: NotificationProps) => {
  useEffect(() => {
    setShow(true);

    setMessages(props.messageList);
    const errorMessages = props.messageList.filter(
      msg => msg.severity?.toLowerCase() === ERROR.toLowerCase()
    );
    if (errorMessages.length > 0) {
      setErrorMessage(errorMessages[0]);
    }
  }, [props.messageList]);

  const [show, setShow] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<Message | undefined>(
    undefined
  );
  const [messages, setMessages] = useState<Message[]>([]);

  const closeHandler = () => {
    if (errorMessage && errorMessage.id) removeNotification(errorMessage?.id);
    setErrorMessage(undefined);
    setShow(false);
  };
  return (
    <div
      id='notification'
      style={
        messages &&
        messages.filter(message => message.severity === INFO).length > 0
          ? { paddingTop: '6px', paddingLeft: '6px' }
          : undefined
      }
    >
      {props.newNotification &&
        messages &&
        (errorMessage ? (
          <Modal
            show={show}
            closeHandler={closeHandler}
            titel={errorMessage.header ?? ''}
            description={errorMessage.message}
          >
            <div className='modal-btn-group'>
              <Button onClickHandler={closeHandler}>Ok</Button>
            </div>
          </Modal>
        ) : (
          messages.filter(message => message.severity === INFO).length > 0 && (
            <Fragment key={'FK'}>
              <div id={'notification_container'}>
                <ul>
                  {messages
                    .filter(message => message.severity === INFO)
                    .map(message => {
                      return (
                        <li className={'notification_message'} key={message.id}>
                          {message.fieldname ? message.fieldname + ':' : ''}{' '}
                          {message.message}
                        </li>
                      );
                    })}
                </ul>
                <div className={'notification_line'} />
              </div>
            </Fragment>
          )
        ))}
    </div>
  );
};
const mapStateToProps = (state: StateModel) => ({
  messageList: state.Notifications.messageList,
  newNotification: state.Notifications.newNotification,
});

export default connect(mapStateToProps, {})(Notification);
